import React, { Component } from 'react'
import { FilterDropdown, ListComponent } from '../../../common/component/Index'
import * as Func from '../../../../../helpers/functions';
import moment from 'moment';
import DEFINE, { CAMPAIGN, DATE_TIME_FORMAT, MARKUP } from '../../../../../constants/Define';
import { Dropdown, Menu, Icon, Tooltip } from 'antd';
import { PATHS } from '../../../../../constants/Define';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { find, toArray } from 'lodash';
import Campaign from "../../../../../models/Campaign";
import Modal from "../../../common/component/Modal";
import { formatValidation } from "../../../../../helpers/functions";

const ListCols = [
    'id',
    'code',
    'campaignCode',
    'name',
    'description',
    'formatCode',
    'productType',
    'totalCount',
    'usedCount',
    'rangeDate',
];
const ModelFields = Object.getOwnPropertyNames(new Campaign());

export class CampaignList extends Component {

    constructor(props) {
        super(props)
        this.state = {
            titleItemTable: Func.getTitleTable(ListCols, ['action'], ['id', 'code']),
            modelItem: ModelFields,
            componentTable: {
                campaignCode: {
                    sorter: (i, k) => i?.code?.length - k.length,
                    key: 'campaignCode',
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            setSelectedKeys={ setSelectedKeys }
                            selectedKeys={ selectedKeys }
                            confirm={ confirm }
                            clearFilters={ clearFilters }
                        >
                        </FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={ { color: filtered ? '#1890ff' : undefined } }/>
                    ),
                    render: (code, record) => record.code
                },
                name: {
                    key: 'campaignName',
                    sorter: (i, k) => i?.name?.length - k.length,
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            setSelectedKeys={ setSelectedKeys }
                            selectedKeys={ selectedKeys }
                            confirm={ confirm }
                            clearFilters={ clearFilters }
                        >
                        </FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={ { color: filtered ? '#1890ff' : undefined } }/>
                    ),
                },
                description: {
                    key: 'description',
                },
                formatCode: {
                    key: 'formatCode',
                    sorter: (i, k) => i?.formatCode?.length - k.length,
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            setSelectedKeys={ setSelectedKeys }
                            selectedKeys={ selectedKeys }
                            confirm={ confirm }
                            clearFilters={ clearFilters }
                        >
                        </FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={ { color: filtered ? '#1890ff' : undefined } }/>
                    ),
                },
                productType: {
                    key: 'productType',
                    render: (products, record) => {
                        return record.displayProductType ? record.displayProductType.map(item => {
                            const type = find([...toArray(CAMPAIGN.PRODUCT_TYPE), ...toArray(MARKUP.CAMPAIGN_TYPE)], type => type.id === item);
                            return type?.label;
                        }).filter(x=>x).join(', ') : ''
                    },
                    filters: [...toArray(CAMPAIGN.PRODUCT_TYPE), ...toArray(MARKUP.CAMPAIGN_TYPE)].filter(x=>x.id !== CAMPAIGN.PRODUCT_TYPE.TOUR.id).map(item => ({ value: item.id, text: item.label })),
                    filterMultiple: false,
                },
                totalCount: {
                    align: 'right',
                },
                usedCount: {
                    align: 'right',
                },
                rangeDate: {
                    key: 'rangeDate',
                    width: 140,
                    render: (text, record) => (
                        record.startTime && record.endTime && Date.parse(record.startTime) > 0 && Date.parse(record.endTime) > 0
                            ? `${ moment(record.startTime).format(DATE_TIME_FORMAT.DATE_TIME) } - ${ moment(record.endTime).format(DATE_TIME_FORMAT.DATE_TIME) }` : ''
                    ),
                },
                action: {
                    width: 90,
                    align: 'center',
                    render: (text, record) => this.renderEditButton(record)
                }
            }
        }
    }

    render() {
        const { loading = false, campaigns, pagination, permissions } = this.props
        const { modelItem, titleItemTable, componentTable } = this.state
        return (
            <ListComponent
                tableKey="campaigns-list"
                classChildren="p-0" classParent="m-0"
                rowKey={ (record, k) => record.id ? record.id : k }
                loading={ { spinning: loading, size: 'large' } }
                dataSource={ Func.getDataSource(campaigns || [], modelItem) }
                columns={ Func.columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'campaign'
                }) }
                onChange={ this.props.onChange }
                pagination={ { total: pagination.totalCount, totalPage: pagination.totalPage, defaultCurrent: pagination.defaultCurrent, defaultPageSize: pagination.pageSize } }
                componentTableList={ {} }
                onColumnVisibleChange={ this.onColumnVisibleChange }
            />
        )
    }

    renderEditButton = (campaign) => {
        const { t, permissions, deleteCampaign, cloneCampaign, pagination } = this.props;
        const permissionPromotion = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.PROMOTION_MANAGEMENT);

        const executeDeleteCampaign = (close) => {
            close();
            deleteCampaign({
                id: campaign.id,
                name: campaign.name,
                filters: {
                    pageSize: pagination.pageSize,
                    pageIndex: pagination.defaultCurrent,
                }
            });
        }

        const onDelete = () => {
            const { confirm } = Modal;
            confirm({
                title: formatValidation(t('validation.statusCode.code.7'), t(`item.campaign.title`)),
                content: campaign.campaignName,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: executeDeleteCampaign,
            });
        };

        const onClone = () => {
            cloneCampaign({
                campaignId: campaign.id,
            });
        }

        return (
            <Dropdown overlay={
                <Menu className="action-menu">
                    { permissions && permissions.allowView &&
                    <Menu.Item>
                        <Link to={ Func.getPathWithParams(PATHS.CAMPAIGN.DETAIL.path, { id: campaign.id }) } className={ `mr-2` }>
                            <Icon type={ (permissions.allowUpdate) ? "form" : "eye" } className="fs20 mr-1 colorPrimary"/>
                            { (permissions.allowUpdate) ? t(`action.edit`) : t(`action.show`) }
                        </Link>
                    </Menu.Item>
                    }
                    {/* {permissionPromotion && permissionPromotion.allowCreate && */}
                         <Menu.Item onClick={ onClone }>
                            <Icon type="plus-square" className="fs20 mr-1 colorPrimary"/> { t(`action.clone`) }
                        </Menu.Item>
                    {/* } */}
                    {
                        permissionPromotion && permissionPromotion.allowView &&
                        <Menu.Item>
                            <Link
                                to={ {
                                    pathname: Func.getPathWithParams(PATHS.PROMOTION.LIST.path, { id: campaign.id, isFromCampaign: true }),
                                    state: { id: campaign.id, isFromCampaign: true }
                                } }
                            >
                                <Icon type="eye" className="fs20 mr-1 colorPrimary"/> { t(`action.bundleViewCode`) }
                            </Link>
                        </Menu.Item>
                    }
                    {
                        permissions && permissions.allowDelete &&
                        <Menu.Item onClick={ onDelete }>
                            <Icon type="delete" className="fs20 mr-1 colorPrimary"/> { t(`action.remove`) }
                        </Menu.Item>
                    }
                </Menu>
            }>
                <Icon type="more" className="fs20 cursorPointer"/>
            </Dropdown>
        )
    }
}

export default withTranslation()(CampaignList)
